import React, { useState, useEffect } from "react";
import { pick } from "underscore";
import { CSVReader } from "react-papaparse";
import { Button, Modal, Tabs, Tab, Row, Col } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { useMutation, queryCache } from "react-query";
import Alert from "react-s-alert";
import { injectIntl, FormattedMessage } from "react-intl";

import { batchPostSpeakers } from "./xhr";
import { cleanObjectAndReturn } from "../../../helpers/cleanObject"
import { UploadCsv, DownloadCsv } from '../../../components/svgs';

export const ExportSpeakers = ({ data }) => {
  return (
    <CSVLink
      data={data.map((row) =>
        pick(
          row,
          "title",
          "firstName",
          "lastName",
          "email",
          "password",
          "phone",
          "description"
        )
      )}
      headers={[
        { label: "Title", key: "title" },
        { label: "First name", key: "firstName" },
        { label: "Last name", key: "lastName" },
        { label: "Email", key: "email" },
        { label: "Password", key: "password" },
        { label: "Phone", key: "phone" },
        { label: "Description", key: "description" },
      ]}
      filename={"eslides-speakers.csv"}
    >
      <Button className="curved-common-button" variant="primary">
        <DownloadCsv />
      </Button>
    </CSVLink>
  );
};

export const ImportSpeakers = injectIntl(({ intl }) => {
  // const [quotes, setQuotes] = useState(false);
  const [show, setShow] = useState(false);

  const [postSpeakerMutation, { isLoading, data }] = useMutation(batchPostSpeakers, {
    onSuccess: (createdSpeakers) => {
      console.log({ createdSpeakers });
      // if (queryCache.getQueryData("speakers")) {
      //   queryCache.setQueryData("speakers", (speakers) =>
      //     speakers.concat([createdSpeaker])
      //   );
      // }
      // Alert.success(intl.formatMessage({ id: "speaker.create-success" }));
      // if (embedded) {
      //   closeModal();
      // } else {
      //   history.push("/speakers");
      // }
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }));
    },
  });
  const batchAddSpeakers = async (values) => {
    // Alert.warning("speaker.creating");
    await postSpeakerMutation({ speakers: values });
  };

  return (
    <div>
      <Button
        className="curved-common-button"
        variant="primary"
        onClick={() => setShow(true)}
      >
        <UploadCsv />
      </Button>
      <Modal
        // className="profile-modal-container"
        show={show}
        onHide={() => setShow(!show)}
        // dialogClassName="profile-modal"
        // backdropClassName="profile-modal-backdrop"
        // aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <FormattedMessage id="heading.purchase-credits" /> */}
            Import CSV
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { /*}
          <label htmlFor="quotes">
            <input type="checkbox" id="quotes" value={quotes} onClick={(e) => setQuotes(e.target.checked)} />
            {' '}Quoted CSV?
          </label>
          */ }
          <CSVReader
            onDrop={(data) => {
              if(data.length === 0) {
                alert("No rows were found.");
                return;
              }

              if(data[0].data[0] === "Title" && data[0].data[1] === "First name") {
                // if header is present
                data = data.slice(1)
              }
              
              try {
                const processedData = data.map(d => cleanObjectAndReturn({
                  "title": d.data['Title'],
                  "firstName": d.data['First name'],
                  "lastName": d.data['Last name'],
                  "email": d.data['Email'],
                  "password": d.data['Password'],
                  "phone": d.data['Phone'],
                  "description": d.data['Description']
                })).filter(d => Object.keys(d).length !== 0)

                if(processedData.length === 0) {
                  alert("No rows were found.");
                  return;
                }

                batchAddSpeakers(processedData)
              } catch (e) {
                alert(e);
              }
            }}
            onError={(err) => {
              console.log("onError: ", err);
            }}
            style={{}}
            config={{
              header: true,
              dynamicTyping: true,
              skipEmptyLines: 'greedy',
              // quotes,
            }}
            addRemoveButton
            onRemoveFile={(data) => {
              console.log("onRemoveFile: ", data);
            }}
          >
            <span><FormattedMessage id="drop-click-csv" /></span>
          </CSVReader>
          
          {
            isLoading && <i>{intl.formatMessage({id: 'processing.csv'})}</i>
          }

          {
            data && <div><br /><ImportResult {...data} /></div>
          }
        </Modal.Body>
      </Modal>
    </div>
  );
});

const ImportResult = ({ createdSpeakers, failedSpeakers }) => {
  useEffect(() => {
    if(queryCache.getQueryData('speakers')) {
      queryCache.setQueryData('speakers', speakers => speakers.concat(createdSpeakers));
    }
  }, [createdSpeakers]);
  return <Tabs defaultActiveKey="created" id="uncontrolled-tab-example">
    <Tab eventKey="created" title={`${createdSpeakers.length} created`}>
      <Row>
        <Col>
          <ol>
            { createdSpeakers.map(s => <li>{s.email}</li>)}
          </ol>
        </Col>
      </Row>
    </Tab>
    <Tab eventKey="failed" title={`${failedSpeakers.length} failed`}>
      <Row>
        <Col>
          <ol>
            { failedSpeakers.map(s => <li>{s.email}</li>)}
          </ol>
        </Col>
      </Row>
    </Tab>
  </Tabs>
}

